import { render, staticRenderFns } from "./BarCarouselNew.vue?vue&type=template&id=1df8e002&"
import script from "./BarCarouselNew.vue?vue&type=script&lang=js&"
export * from "./BarCarouselNew.vue?vue&type=script&lang=js&"
import style0 from "./BarCarouselNew.vue?vue&type=style&index=0&id=1df8e002&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports